import { Lock, Loader2 } from "lucide-react";
import { Link } from "react-router-dom";

export default function MembershipGateNotice({ member, isLoading, testid = "membership-gate" }) {
  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-10" data-testid={`${testid}-loading`}>
        <Loader2 className="h-5 w-5 animate-spin text-ptf-primary" />
      </div>
    );
  }
  return (
    <div data-testid={testid} className="border border-ptf-primary/15 bg-ptf-primary/[0.03] p-7 md:p-10 text-center">
      <span className="inline-grid place-items-center h-12 w-12 rounded-full bg-ptf-primary/10 text-ptf-primary mb-4">
        <Lock className="h-5 w-5" />
      </span>
      <h3 className="font-display uppercase text-2xl tracking-tight text-ptf-primary">
        {!member ? "Membership required" : "Active membership required"}
      </h3>
      <p className="mt-3 text-sm text-ptf-text/70 leading-relaxed max-w-md mx-auto">
        {!member
          ? "Create a free Planet Trotter account and take up a membership plan to apply for Training or Volunteering."
          : "Your account doesn't have an active membership yet. Choose a membership plan to unlock this application."}
      </p>
      <Link
        to="/account"
        data-testid={`${testid}-cta`}
        className="mt-6 inline-flex items-center gap-2 bg-ptf-primary text-ptf-bg px-8 py-3.5 text-[0.7rem] font-semibold uppercase tracking-[0.18em] hover:bg-ptf-secondary transition"
      >
        {!member ? "Sign Up / Log In" : "View Membership Plans"}
      </Link>
    </div>
  );
}
